import React from "react";
import styles from "./custom-attendance-calendar.module.css";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";

const CustomAttendanceCalendar = ({
  eventData,
  height = 400,
  views = ["month", "week", "day"],
  defaultView = "month",
  defaultDate = new Date()
}) => {
  const localizer = momentLocalizer(moment);

  const eventPropGetter = (event) => {
    const style = {
      backgroundColor: "transparent", // Remove background
      border: "none", // Remove border
      boxShadow: "none", // Remove box shadow
      padding: "0", // Remove padding
    };

    return {
      className: "", // Remove any default classes
      style,
    };
  };
  return (
    <div className={styles.calendarWrapper}>
    <Calendar
      localizer={localizer}
      events={eventData}
      startAccessor="start"
      endAccessor="end"
      views={views}
      defaultView={defaultView}
      defaultDate={defaultDate}
      eventPropGetter={eventPropGetter}
      components={{
        event: ({ event }) => (
           <div className={styles.customEvent}>
            {event.component}
          </div>
        ),
      }}
      style={{ height: height }}
    />
    </div>
  );
};

export default CustomAttendanceCalendar;
